import React from 'react';
import { Certificate } from '../../../types/rest/assetCatalogTypes';
import BlazeTable from '../../../components/blazeTable/BlazeTable';
import { BlazeTableColDef, BlazeTableOptions } from '../../../components/blazeTable/BlazeTable.types';
import i18n from '../../../i18n';
import BlazeTableActions from '../../../components/blazeTable/BlazeTableActions';
import { Button } from 'react-bootstrap';
import BzmIcon from '../../../components/icons/BzmIcon';
import { useDispatch } from 'react-redux';
import { downloadAsset } from '../../../store/certificates/certificatesActions';
import { isKeystoreFile } from '../../../utils/assetUtils';
import acApi from '../../../axios/ac/acApi';
import { isAliasesListFullGrantedFromMeta } from './CertificateDetailsModal';

interface ClientCertificatesTableProps {
  certificates: Certificate[];
  onSelectionChange: (selectedItems: Array<any>) => void;
  onDelete: (cert: Certificate) => void;
  onOpenDetail: (cert: Certificate) => void;
  selectedItems: number[];
  isLoading: boolean;
}

const CertificatesTable = (props: ClientCertificatesTableProps) => {
  const callCert = async (cert: Certificate) => {
    const response = (await acApi.assets.getById(cert.id)).data.result;
    props.onOpenDetail(response);
  };

  const dispatch = useDispatch();

  const colsDefinition: BlazeTableColDef[] = [
    {
      header: 'Certificate Name',
      accessor: 'name',
    },
    {
      header: 'Created Date',
      accessor: 'createdDate',
    },
    {
      header: 'Created by',
      accessor: 'createdBy',
    },
    {
      header: 'Type',
      accessor: 'type',
      cellComponent: cert => {
        return isKeystoreFile(cert.name) ? 'Keystore' : 'Certificate';
      },
    },
    {
      header: 'Actions',
      headerComponent: <div className={'text-center'}>Actions</div>,
      width: 130,
      cellClass: 'text-right',
      accessor: 'value',
      isSortable: false,
      cellComponent: cert => {
        return (
          <div className={'text-center'}>
            <BlazeTableActions>
              <Button className={'btn-link-dark btn-no-hover'}>
                <BzmIcon
                  variant={
                    isKeystoreFile(cert.name) && !isAliasesListFullGrantedFromMeta(cert.primaryMetadata?.aliases)
                      ? 'icon-bzm-edit'
                      : 'icon-bzm-show'
                  }
                  className={'icon-xs'}
                  onClick={() => callCert(cert)}
                />
              </Button>
              <Button className={'btn-link-dark btn-no-hover'}>
                <BzmIcon variant={'icon-bzm-delete'} className={'icon-xs'} onClick={() => props.onDelete(cert)} />
              </Button>
              <Button className={'btn-link-dark btn-no-hover'}>
                <BzmIcon
                  variant={'icon-bzm-download'}
                  className={'icon-xs'}
                  onClick={() => {
                    dispatch(downloadAsset(cert));
                  }}
                />
              </Button>
            </BlazeTableActions>
          </div>
        );
      },
    },
  ];

  const tableOptions: BlazeTableOptions = {
    showRowExpander: false,
    columnDef: colsDefinition,
    pageable: true,
    selectable: true,
    selectAllDropdown: true,
    sortable: true,
    tableName: 'certificatesList',
    noResultsText: i18n.t('certificates:table.noResults'),
  };

  return (
    <BlazeTable
      selectedItems={props.selectedItems}
      onSelectionChange={props.onSelectionChange}
      options={tableOptions}
      data={props.certificates}
      isLoading={props.isLoading}
    />
  );
};

export default CertificatesTable;
